var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-action",class:{ 'btn-primary': _vm.sunburstVisible},on:{"click":function($event){return _vm.toggleSunburstPane()}}},[_c('i',{staticClass:"fas fa-dot-circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }